import { Component, inject, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EvidaFullRoutes } from 'src/app/evida/models/evida-routes.model'

@Component({
    selector: 'app-edit-associated-user-error',
    templateUrl: './edit-associated-user-error.component.html',
    styleUrls: ['./edit-associated-user-error.component.scss'],
    standalone: false,
})
export class EditAssociatedUserErrorComponent implements OnInit {
    private router = inject(Router)

    public ngOnInit(): void {
        console.log('init', typeof this)
    }

    public goBack() {
        return this.router.navigate([EvidaFullRoutes.admin])
    }
}
